/**
 * Dummy IUISurvey implementation without dependancy on officefloodgatecore
 */
import * as Utils from "../../Utils";
import * as Api from "@ms-ofb/officefloodgatecore/dist/src/Api/Api";
export default class DummySurvey {
  constructor() {
    this.showPrompt = true;
    this.showEmailRequest = true;
    this.comment = "";
  }
  getPromptQuestion() {
    return "Prompt question?";
  }
  getTitle() {
    return "Title";
  }
  getPromptYesButtonText() {
    return "Yes";
  }
  getPromptNoButtonText() {
    return "No";
  }
  getRatingValuesAscending() {
    return ["worst", "worse", "ok", "better", "best"];
  }
  getRatingQuestion() {
    return "Rating question?";
  }
  getCommentQuestion() {
    return "Comment question?";
  }
  getInterceptTitle() {
    return "Intercept Title";
  }
  getInterceptQuestion() {
    return "Intercept question?";
  }
  getInterceptUrl() {
    return "https://example.com";
  }
  setValues(selectedIndex, comment) {
    if (comment) {
      this.comment = comment;
    }
    if (Utils.isInteger(selectedIndex) && selectedIndex >= 0 && selectedIndex <= 4) {
      this.rating = selectedIndex / 4.0;
    }
  }
  getJsonElements() {
    let result = {};
    if (this.comment) {
      result.comment = this.comment;
    }
    if (this.rating) {
      result.rating = this.rating;
    }
    return result;
  }
  getSurveyType() {
    return Api.ISurvey.Type.Nps;
  }
  getCampaignId() {
    return "10000000-0000-0000-0000-000000000000";
  }
  getId() {
    return "00000000-0000-0000-0000-000000000000";
  }
}